// extracted by mini-css-extract-plugin
module.exports = {"row":"ClientSessions_row__3mIru","flip":"ClientSessions_flip__FUS8U"};